import { render, staticRenderFns } from "./TrainDetail.vue?vue&type=template&id=5b2826ae&scoped=true"
import script from "./TrainDetail.vue?vue&type=script&lang=js"
export * from "./TrainDetail.vue?vue&type=script&lang=js"
import style0 from "./TrainDetail.vue?vue&type=style&index=0&id=5b2826ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2826ae",
  null
  
)

export default component.exports